import type { SelectHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

/**
 * A native select. Deliberately not a custom listbox: this is an
 * administrative form, and the platform-provided control is the one that is
 * keyboard-accessible and screen-reader correct without any work from us.
 */
export function Select({ className, ...props }: SelectProps) {
  return (
    <select
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}
